/* PIRANGA: explicit size confirmation before purchase. Scoped to product page. */
(function () {
  // Visual marker that does not depend on theme CSS: label.piranga-selected for the checked colour.
  function markSelected(scope) {
    (scope || document).querySelectorAll('.variants-wrapper:not([data-piranga-size-option])').forEach(function (w) {
      var radios = Array.prototype.filter.call(w.querySelectorAll('input[type="radio"]'), function (r) { return r.closest('.variants-wrapper') === w; });
      if (!radios.length) return;
      var sel = null;
      radios.forEach(function (r) { if (!sel && r.checked) sel = r; });
      if (!sel) {                                   // nothing checked: use the server default, or the only swatch, and really check it
        radios.forEach(function (r) { if (!sel && r.parentElement && r.parentElement.hasAttribute('data-pi-default')) sel = r; });
        if (!sel && radios.length === 1) sel = radios[0];
        if (!sel) radios.forEach(function (r) { if (!sel && !r.disabled) sel = r; });
        if (sel) sel.checked = true;
      }
      // The hidden "more colours" drawer repeats every swatch under the same radio name, and on load the browser checks that copy. Move the selection to the visible twin.
      if (sel && sel.closest('.fixed-variant_image')) {
        var twin = null;
        radios.forEach(function (r) { if (!twin && r.value === sel.value && !r.closest('.fixed-variant_image')) twin = r; });
        if (twin) { twin.checked = true; sel = twin; }
      }
      radios.forEach(function (r) {
        var on = (r === sel);
        var lab = r.nextElementSibling;
        while (lab && lab.tagName !== 'LABEL') lab = lab.nextElementSibling;
        if (lab) lab.classList.toggle('piranga-selected', on);
        if (r.parentElement) r.parentElement.classList.toggle('piranga-sel', on);
        var holder = r.parentElement;
        if (holder) {
          var bar = null;
          Array.prototype.forEach.call(holder.children, function (c) { if (c.classList && c.classList.contains('pi-underline')) bar = c; });
          if (on && !bar) {
            bar = document.createElement('span');
            bar.className = 'pi-underline';
            bar.setAttribute('aria-hidden', 'true');
            var st = bar.style;
            st.setProperty('position', 'absolute', 'important'); st.setProperty('left', '0', 'important'); st.setProperty('right', '0', 'important');
            st.setProperty('bottom', '0', 'important'); st.setProperty('height', '1px', 'important'); st.setProperty('background', '#111', 'important');
            st.setProperty('display', 'block', 'important'); st.setProperty('z-index', '9', 'important'); st.setProperty('pointer-events', 'none', 'important');
            holder.style.setProperty('position', 'relative', 'important');
            holder.appendChild(bar);
          } else if (!on && bar) { bar.parentNode.removeChild(bar); }
        }
      });
      if (sel) {
        var nm = w.querySelector('.variants__label span');
        if (nm && nm.textContent !== sel.value) nm.textContent = sel.value;   // colour name always matches the selection
      }
    });
  }
// Colour must always be selected (default, ?color=, ?variant=, or the swatch picked on a card).
function preselectColor(form) {
      var m = location.search.match(/[?&]variant=(\d+)/);
      var product = null;
      try { var pj = document.querySelector('script[id^="ProductJson-"]'); product = pj ? JSON.parse(pj.textContent) : null; } catch (e) {}
      var changed = [];
      form.querySelectorAll('.variants-wrapper:not([data-piranga-size-option])').forEach(function (wrap) {
        var radios = Array.prototype.slice.call(wrap.querySelectorAll('input[type="radio"]'));
        if (!radios.length) return;
        var idx = parseInt((radios[0].getAttribute('data-index') || 'option1').replace('option', ''), 10) - 1;
        var wanted = null;
        // 1) colour carried from a product card (?color=... or the remembered swatch click)
        var nameEl = wrap.querySelector('.piranga-label__name');
        var isColour = nameEl && /colo/i.test(nameEl.textContent || '');
        var carried = null;
        try { carried = new URLSearchParams(location.search).get('color'); } catch (e) {}
        if (!carried) {
          try {
            var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
            var saved = h && JSON.parse(sessionStorage.getItem('piranga:color:' + h) || 'null');
            if (saved && saved.value && (isColour || radios[0].getAttribute('data-index') === saved.index)) carried = saved.value;
          } catch (e) {}
        }
        if (carried && isColour) radios.forEach(function (r) { if (!wanted && r.value.toLowerCase() === String(carried).toLowerCase() && !r.disabled) wanted = r.value; });
        // 2) ?variant=ID
        if (!wanted && m && product && product.variants) {
          product.variants.forEach(function (v) { if (String(v.id) === m[1]) wanted = v.options[idx]; });
        }
        var target = null;
        if (wanted) radios.forEach(function (r) { if (r.value === wanted) target = r; });
        if (!target) radios.forEach(function (r) { if (!target && r.checked) target = r; });
        if (!target) radios.forEach(function (r) { if (!target && r.parentElement && r.parentElement.hasAttribute('data-pi-default')) target = r; });
        if (!target) radios.forEach(function (r) { if (!target && !r.disabled) target = r; });
        if (!target) target = radios[0];
        if (!target.checked) { target.checked = true; changed.push(target); }
        var lab = wrap.querySelector('.variants__label span');
        if (lab) lab.textContent = target.value;
      });
      // let the theme swap gallery / price once its own scripts are ready
      if (changed.length) window.addEventListener('load', function () {
        setTimeout(function () { changed.forEach(function (r) { r.dispatchEvent(new Event('change', { bubbles: true })); }); }, 300);
      });
    }
  function initialize(root) {
    root.querySelectorAll('form.piranga-guarded-form').forEach(function (form) {
      if (form.dataset.pirangaInitialized) return;
      form.dataset.pirangaInitialized = 'true';
      preselectColor(form);
      markSelected(form);
      var size = form.querySelector('[data-piranga-size-option]');
      if (!size) return; // Products without Size option retain regular purchase flow.
      var add = form.querySelector('.product-single__add-to-cart button[name="add"]');
      var displays = size.querySelectorAll('[data-piranga-size-display], .variants__label span');
      var selected = false;
      form.classList.add('piranga-size-pending');
      var initialButtonText = add && add.querySelector('.btn__text') ? add.querySelector('.btn__text').textContent.trim() : 'Add to cart';
      var payment = form.querySelector('.shopify-payment-button');
      var stock = size.querySelector('[data-piranga-stock]');
      // Button text slides up and fades while the new text rises from below (the ::after layer in custom.css), then the real label takes over.
      function slide(text) {
        if (!add || !add.querySelector('.btn__text')) return;
        if (add.classList.contains('piranga-slide') && add.getAttribute('data-pi-label') === text) return;
        add.setAttribute('data-pi-label', text);
        add.classList.remove('piranga-slide');
        void add.offsetWidth;
        add.classList.add('piranga-slide');
        clearTimeout(add._piSlide);
        add._piSlide = setTimeout(function () {
          var label = add.querySelector('.btn__text');
          if (label) label.textContent = text;
          add.classList.remove('piranga-slide');
        }, 300);
      }
      // No shake, no message: the button repeats SELECT A SIZE. Scroll only when the sizes are off screen, so a tap on the sticky bar still leads somewhere.
      function remind() {
        slide('SELECT A SIZE');
        var box = size.getBoundingClientRect();
        if (box.top < 70 || box.bottom > window.innerHeight) size.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      function prompt() {
        displays.forEach(function (node) { node.textContent = 'Select size'; });
        if (add && !add.disabled) {
          var label = add.querySelector('.btn__text');
          if (label) label.textContent = 'SELECT A SIZE';
        }
        if (payment) payment.hidden = true;
        if (stock) stock.hidden = true;
      }
      function accept() {
        selected = true;
        form.classList.remove('piranga-size-pending');
        if (payment) payment.hidden = false;
        if (stock) stock.hidden = false;
        slide(initialButtonText);
      }
      // Keep the variant ID intact for Shopify's variant switching script; never fake a SKU.
      size.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = false;
        input.addEventListener('change', function () { if (input.checked && !input.disabled) accept(); });
      });
      size.querySelectorAll('select').forEach(function (select) {
        var empty = document.createElement('option');
        empty.value = ''; empty.textContent = 'Select Size'; empty.selected = true; empty.disabled = true;
        select.insertBefore(empty, select.firstChild);
        select.value = '';
        select.addEventListener('change', function () { if (select.value) accept(); });
      });
      form._pirangaAccept = function (value) { displays.forEach(function (n) { n.textContent = value; }); accept(); };
      prompt();
      // The theme rewrites the button text ("Add to cart") after a colour change; while no size is chosen it must keep saying SELECT A SIZE.
      // wpbingo's _updateBtnText replaces the .btn__text node itself with a fresh copy from the server, so watch the button and look the node up each time.
      if (add) {
        new MutationObserver(function () {
          var btnText = add.querySelector('.btn__text');
          if (btnText && !selected && !add.disabled && btnText.textContent.trim() !== 'SELECT A SIZE') btnText.textContent = 'SELECT A SIZE';
        }).observe(add, { childList: true, characterData: true, subtree: true });
      }
      form.querySelectorAll('.variants-wrapper:not([data-piranga-size-option]) input[type=radio]').forEach(function (colorInput) {
        colorInput.addEventListener('change', function () {
          selected = false;
          form.classList.add('piranga-size-pending');
          size.querySelectorAll('input[type=radio]').forEach(function (input) { input.checked = false; });
          prompt();
        });
      });
      // Capturing submission covers both native and JS-based add-to-cart handlers.
      form.addEventListener('submit', function (ev) {
        markSelected(form);
        if (selected) return;
        ev.preventDefault(); ev.stopImmediatePropagation();
        remind();
        var choice = size.querySelector('input[type="radio"]:not([disabled]), select');
        if (choice) choice.focus({ preventScroll: true });
      }, true);
      if (add) add.addEventListener('click', function (ev) {
        markSelected(form);
        if (selected) return;
        ev.preventDefault(); ev.stopImmediatePropagation();
        remind();
      }, true);
    });
  }
  // Delegated size click: guarantees the size registers even if another script swallows the label's native toggle.
  document.addEventListener('click', function (ev) {
    var label = ev.target.closest && ev.target.closest('[data-piranga-size-option] .single-option-selector label');
    if (!label) return;
    var wrap = label.closest('[data-piranga-size-option]');
    var form = label.closest('form.piranga-guarded-form');
    if (!wrap || !form) return;
    var input = null;
    wrap.querySelectorAll('input[type="radio"]').forEach(function (i) { if (i.id === label.getAttribute('for')) input = i; });
    if (!input || input.disabled) return;
    if (!input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (form._pirangaAccept) form._pirangaAccept(input.value);
  });
  document.addEventListener('change', function () { setTimeout(function () { markSelected(document); }, 0); });
  document.addEventListener('click', function () { setTimeout(function () { markSelected(document); }, 30); });
  // Keep exactly one colour selected + marked, even if the theme re-renders the form after load.
  function ensureColour() {
    document.querySelectorAll('form.piranga-guarded-form').forEach(function (f) {
      var missing = Array.prototype.some.call(f.querySelectorAll('.variants-wrapper:not([data-piranga-size-option])'), function (w) {
        return w.querySelector('input[type="radio"]') && !w.querySelector('input[type="radio"]:checked');
      });
      if (missing) preselectColor(f);
    });
    markSelected(document);
  }
  window.addEventListener('load', function () {
    [0, 800, 3000].forEach(function (d) { setTimeout(ensureColour, d); });
    var root = document.querySelector('.product-single__metas') || document.body;
    var timer = null, until = Date.now() + 6000;
    var mo = new MutationObserver(function () {
      if (Date.now() > until) { mo.disconnect(); return; }
      clearTimeout(timer); timer = setTimeout(ensureColour, 80);
    });
    mo.observe(root, { childList: true, subtree: true });
  });

  // Diagnostics: add ?pi_debug=1 to any product URL to see the live state on screen.
  (function () {
    if (!/[?&]pi_debug=1/.test(location.search)) return;
    function draw() {
      var box = document.getElementById('pi-debug');
      if (!box) {
        box = document.createElement('pre'); box.id = 'pi-debug';
        box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:2147483647;max-height:45vh;overflow:auto;margin:0;padding:10px;background:#000;color:#0f0;font:11px/1.35 monospace;white-space:pre-wrap;border-radius:6px';
        document.body.appendChild(box);
      }
      var L = ['build=' + (window.PIRANGA_BUILD || 'none') + '  w=' + innerWidth + '  nativeGallery=' + document.documentElement.classList.contains('piranga-native-gallery') + '  slick=' + !!document.querySelector('.js-product-media-group.slick-initialized')];
      L.push('url=' + location.pathname + location.search);
      document.querySelectorAll('form.piranga-guarded-form .variants-wrapper').forEach(function (w) {
        var nm = (w.querySelector('.variants__label strong') || {}).textContent || '?';
        L.push('[' + nm + '] label="' + ((w.querySelector('.variants__label span') || {}).textContent || '') + '"');
        w.querySelectorAll('input[type=radio]').forEach(function (r) {
          var lab = r.nextElementSibling;
          L.push('   ' + r.value + '  checked=' + r.checked + '  disabled=' + r.disabled + '  labelClass="' + (lab ? lab.className : '-') + '"  wrapSel=' + (r.parentElement && r.parentElement.classList.contains('piranga-sel')));
        });
      });
      L.push('gallery items=' + document.querySelectorAll('.js-product-media-item').length + '  addBtn=' + !!document.querySelector('.product-single__add-to-cart button[name=add]') + '  stickyBar=' + !!document.querySelector('.piranga-sticky-atc'));
      box.textContent = L.join('\n');
    }
    window.addEventListener('load', function () { draw(); setInterval(draw, 700); });
  })();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
